<template>
	<div class="ht-detail">
		<!-- <el-backtop target=".planSearch" :bottom="100"></el-backtop> -->
		<div class="container">
			<div class="container-left">
				<!--左边多张图片-->
				<div class="hotel-imgs">
					<div class="imgs-top">
						<p>{{ detalisInfo.jdmc }}</p>
						<el-rate :colors="['#FF9524', '#FF9524', '#FF9524']" :disabled="true"
							:value="Number(detalisInfo.category)"></el-rate>
					</div>
					<div class="imgs-center">
						<p>{{ detalisInfo.jdmcEn }}</p>
					</div>
					<div class="f12 mt4" style="font-size:12px;margin-top:4px;margin-bottom:12px;display:flex">
						<div class="yjStyle" v-if="detalisInfo.depositPolicy && detalisInfo.depositPolicy.amount">有押金</div>
						<div class="center-center" v-if="detalisInfo.reviewCommonScore">
							<p class="score-desc">{{ getScoreDesc(detalisInfo.reviewCommonScore || 5) }}</p>
							<p v-if="detalisInfo.establishmentDateDesc" style="margin-left: 4px;">{{
								establishmentDateStr(detalisInfo.establishmentDate) }}</p>
						</div>
					</div>
					<div class="imgs-bottom">
						<div class="imgs-left" @click="selectImg(0)">
							<img v-if="firstImage" :src="firstImage" class="img" alt="">
							<img v-else src="../../assets/image/ht/icon_htfx_empty.png" class="img" alt="">
							<span>查看所有的图片（{{ objArrImg.length }}张)</span>
						</div>
						<div class="ims-right">
							<el-image v-for="(item, idx) in objArrImgSplice" :key="item.index" :src="item.img" class="img"
								@click="selectImg(idx + 1)" v-show="item">
								<div slot="error" style="width:100%;height:100%">
								</div>
							</el-image>
						</div>
					</div>
				</div>
				<!--左边底部酒店信息-->
				<div class="left-tabs">
					<span :class="{ to_active: tabsShow === 1 }" @click="handleTab(1)">房型</span>
					<span :class="{ to_active: tabsShow === 2 }" @click="handleTab(2)">酒店信息</span>
					<span :class="{ to_active: tabsShow === 3 }" @click="handleTab(3)">交通</span>
				</div>
				<!--左边底部酒店搜索模块-->
				<div class="gj-tips">
					<span>不同国籍人员请分开下单</span>
				</div>
				<div class="home-search searchItem" v-if="tabsShow == 1">
					<el-date-picker v-model="dateValue" type="daterange" format="yyyy-MM-dd" @change="changeDate"
						:picker-options="pickerOptions(bookDateRange.minDay, bookDateRange.maxDay)" value-format="yyyy-MM-dd"
						range-separator="至" start-placeholder="入住日期" end-placeholder="结束日期">
					</el-date-picker>
					<RoomAndAdult :rNum="htCnParams.roomNum" :trip-type="tripType" :aNum="htCnParams.adultNum"
						:cxrLength="chooseCxrList.length" @select="selectRoomNumCallback" />
					<el-select placeholder="请选择国籍" filterable clearable @change='changeSelect' style="width:150px"
						v-model="searchParams.nationalityId">
						<el-option :value='item.id' :label='item.label' v-for='item in gjList' :key="item.id">（{{ item.value }}）{{
							item.label
						}}</el-option>
					</el-select>
					<div class="flexBet">
						<div class="searchBtn" @click="getPlanSearch">搜索酒店</div>
					</div>
				</div>
				<div v-show="!isShowRomms && !loading" class="textRomms">
					<span style="color:#808080">未能获取到酒店价格，建议进行</span>
					<span style="color: #52b5f8; cursor:pointer;" @click="seePriceHander">人工询价</span>
				</div>

				<div v-if="loading" v-loading="loading" element-loading-text="拼命加载中..."
					element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)"
					style="width: 100%; background-color: #fff; height: 200px;">
				</div>

				<div v-show="!loading">
					<div v-for="(room, roomListIndex) in roomList" :key="roomListIndex" style="margin-top: 12px"
						v-show="isShowRomms && room.show && tabsShow == 1">
						<div class="planSearch">
							<div class="leftBox">
								<img v-if="room.url" :src="room.url" alt="">
								<img v-else src="../../assets/image/ht/icon_htfx_empty.png" alt="">
								<div class="fxmc">{{ room.roomName }}</div>
								<div class="cxmc" style="padding-top: 4px">
									<span style="padding:0 4px" v-for="desc in getRoomDesc(room)" :key="desc">{{ desc }}</span>
								</div>
							</div>
							<div class="rightBox">
								<div @click="clickAll(room)" class="lookMore" v-if="room.ratePlans.length > 2 && room.itemShow">
									<i class='el-icon-arrow-up'></i>
									<span style="padding-left:6px;cursor: pointer;">收起全部报价</span>
								</div>
								<div class="fxBox" v-for="(ratePlan, index) in room.ratePlans" v-show='ifShowMore(room, index)'
									:key="index">
									<div>
										<div class="flex-x-s fBold f14">
											<div v-if="tripType == TripTypeMap.onbusiness && ratePlan.violate" class="cb-tag flex-x-c">
												<span class="f10 fw4">超标</span>
											</div>
											<span v-if="tripType == TripTypeMap.onbusiness && ratePlan.violate" class="line"></span>
											<span class="roomNameStyle">{{ ratePlan.rpName }}</span>
										</div>
										<div class="flex-x-s">
											<div class="hyqy-tag" @click="hyqyClick(ratePlan)"
												v-if="ratePlan.memberBenefit && ratePlan.memberBenefit.length > 0">
												<img style="width: 24rpx; height: 24rpx; margin-right: 4rpx;" mode="aspectFill"
													src="@/assets/image/ht/icon_ht_hyqy.png" />
												<span class="cblue f10" style="line-height: 24rpx;">会员权益</span>
												<span class="iconfont iconfont-2 icon-arrow-right-2 cblue f12"></span>
											</div>
											<!-- TODO: season测试使用 上线需要注释 -->
											<!-- <div class="room-tag bgred" v-if="ratePlan.fyName">
												<span class="cwhite">{{ ratePlan.fyName }}</span>
											</div> -->
											<div class="room-tag" v-if="!!ratePlan.bedDesc">
												<span>{{ ratePlan.bedDesc }}</span>
											</div>
											<div class="room-tag b-theme"
												v-if="ratePlan.bussType == BussType.xyj ||
													(ratePlan.bussType != BussType.fws && ratePlan.bussType != BussType.xyj && ratePlan.fyName && ratePlan.corpGroup == 1)">
												<span class="ctheme">协议</span>
											</div>
											<div class="room-tag" :class="[!ratePlan.freeMeal ? 'cred red-border' : 'ctheme b-theme']">
												<span>{{ getFreeMealStr(ratePlan.freeMeal) }}</span>
											</div>
											<div class="room-tag" v-if="!!ratePlan.invoiceType && InvoiceTypeName[ratePlan.invoiceType]">
												<span>{{ InvoiceTypeName[ratePlan.invoiceType] }}</span>
											</div>
											<div class="room-tag" v-if="ratePlan.bookEquity">
												<span>嘉享</span>
											</div>
											<div class="room-tag" v-if="ratePlan.pointsType == 1">
												<span>嘉享积分</span>
											</div>
											<div class="room-tag" v-if="ratePlan.bookingRule && ratePlan.bookingRule.maxRoomCount == 1">
												<span>1单1间</span>
											</div>
											<div class="ml4" @click="lookRzxz(ratePlan)"
												v-if="ratePlan.hotelPolicy && Object.keys(ratePlan.hotelPolicy).length > 0">
												<span class="iconfont icon-tubiao-wenhao f13 ctheme"></span>
												<span class="ctheme f12 ml2">入住须知</span>
											</div>
										</div>
										<div style="width:400px;text-align:left" v-if="ratePlan.prepayRule">
											<i style="margin-right: 2px;font-size: 12px;" :class="`iconfont  ${ratePlan.shortRule ==
												ShortRuleType.noCancel ? 'el-icon-circle-close cred' : 'el-icon-circle-check ctheme'}`"></i>
											<span style="font-size:12px"
												:class="`${ratePlan.shortRule == ShortRuleType.noCancel ? 'cred' : 'ctheme'}`">{{
													ratePlan.shortRule ==
														ShortRuleType.noCancel ? '取消规则:' : '' }}{{ ratePlan.prepayRule.description }}</span>
										</div>
									</div>
									<!-- 订 -->
									<div class="rightBtn">
										<div>
											<div>
												<span style="font-size:10px;color:#9c9c9c">含税/费</span>
												<span style="font-size:10px;color:#F7613F">¥</span>
												<span style="font-size:20px;color:#F7613F">{{ ratePlan.averageRate ?
													Math.ceil(ratePlan.averageRate) : '' }}</span>
												<span style="font-size:10px;color:#F7613F">起</span>
											</div>
											<div v-if="ratePlan.additionalTax && ratePlan.additionalTax.localTotalAmount"
												style="font-size:12px;">
												<span>到店另付其他税/费</span>
												<span>{{ ratePlan.additionalTax.localTotalAmount }}</span>
												<span>{{ ratePlan.additionalTax.localCurrency }}</span>
											</div>
										</div>
										<div
											:class="`buy-btn ${!canBook(ratePlan) ? 'grey-plan' : ''} ${ratePlan.allRoomStatus != 2 && ratePlan.quantity < 5 ? 'jz-btn' : ''}`">
											<div :class="['ding flex-x-c', !canBook(ratePlan) ? 'bggrey1' : 'bgtheme']">
												<span @click="bookRatePlan(ratePlan, room)">{{ ratePlan.allRoomStatus == 2 ? "满" : "订" }}</span>
											</div>
											<div class="h-tips flex-x-c" v-if="ratePlan.allRoomStatus != 2 && ratePlan.quantity < 5">
												<span class="h-tips flex-x-c" v-if="ratePlan.quantity < 5">紧张</span>
												<span class="ctheme" v-else>充足</span>
											</div>
										</div>
									</div>
								</div>
								<div @click="clickAll(room)" class="lookMore" v-if="room.ratePlans.length > 2 && !room.itemShow">
									<i class='el-icon-arrow-down'></i>
									<span style="padding-left:6px;cursor: pointer;">查看全部报价</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--左边底部酒店信息-->
				<div class="hotel-info" v-if="tabsShow == 2">
					<IntHotelInfoDetail :detail="detalisInfo"></IntHotelInfoDetail>
				</div>
				<div class="hotel-info" v-if="tabsShow == 3"></div>
			</div>
			<!--右侧模块-->
			<div class="container-right">
				<!--地图模块-->
				<div class="map" @click="dialogMap">
					<img src="@/assets/image/htcnbgc/map.png" alt="" />
				</div>
				<!--差旅模块-->
				<div class="standard" v-if="htCnQuery.tripType == 1">
					<div v-if="htCnQuery.gkfsRole == 1 && bookStyle == 2">
						<p>差旅标准</p>
						<span>
							本次预订每间房价不得高于<span style="color: red;">{{ htCnCcsqD.currentRoute ? htCnCcsqD.currentRoute.fyys : ''
							}}元</span>/夜
						</span>
					</div>
					<div
						v-if="JSON.stringify(policy) != '{}' && ((htCnQuery.gkfsRole == 2 && bookStyle == 2) || (bookStyle == 1))">
						<p>差旅标准</p>
						<div class="clbz-clbzText" style="font-size: 15px;">
							{{ policy.mulPerson == 1 ? '已开启' : '未开启' }}多人差标模式
						</div>
						<div class="clbz-user" v-show="policy.mulPerson != 1">
							本次预订采用<span style="opacity: 1;color: #4089FF; font-size: 15px;">{{ useNameclbz }}</span>的差旅标准
						</div>
						<div class="clbz-user" v-show="policy.mulPerson == 1">
							本次预订采用<span style="opacity: 1;color: #4089FF;font-size: 15px;">入住人{{ policy.mulPersonStandardDesc
							}}</span>的差旅标准
						</div>
						<span v-if="jdjgbz != void 0" style="font-size: 15px; font-weight: bold;">酒店订房 不超过 <span
								style="color: red;font-size: 15px; font-weight: bold;">{{ jdjgbz }}元</span>/间</span>
					</div>
					<div v-if="htCnQuery.gkfsRole == 0 && bookStyle == 2">
						<p>差旅标准</p>
						<span>差旅标准未管控</span>
					</div>
				</div>
			</div>

		</div>
		<htCnDeatilsTabs :detalisInfo="detalisInfo" :athoerHoterList="athoerHoterList" :dialogShow.sync="dialogShow" />
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList">
		</el-image-viewer>
		<IntHtImgPop :imgArray="typeImgArray" :imgDefaultIdx="showIdx" :htDetails="detalisInfo" v-model="showAllImg" />
		<!-- 违背原因选择 -->
		<yj-violation :vltShow="showWbPop" @cancelReason="cancelReason" :vltReason="clbzText" byNumber="10903"
			@chooseReason="chooseReason">
		</yj-violation>
		<roomRzxz @close="handleClose" @hasKown='hasKown' :dialogVisible="showRzxz" :currentRatePlan="currentRatePlan">
		</roomRzxz>
	</div>
</template>
<script>

import mixin from './../../mixin';
import htCnDeatilsTabs from '../../views/htCn/HtCnComponent/htCnDeatilsTabs.vue';
import IntHtImgPop from './components/intHtImgPop.vue';
import IntHotelInfoDetail from './components/intHotelInfoDetail.vue'
import { Loading } from 'element-ui';
import RoomAndAdult from './components/RoomAndAdult.vue'
import { establishmentDateStr, handleIntYsRooms } from '../../hooks/useHotel.js'
import {
	mapGetters,
	mapMutations, mapState
} from 'vuex';
import hotelmixin from './../../mixin/models/hotelMixin.js';
import roomRzxz from './components/roomRzxz.vue'
import { handleIntHotelRoom } from '../../hooks/useHotel.js';

export default {
	name: 'interHotelDetail',
	mixins: [mixin.ccsqdMixin, hotelmixin.hotelCxrListCtrl],
	components: {
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
		htCnDeatilsTabs,
		IntHtImgPop,
		IntHotelInfoDetail,
		roomRzxz,
		RoomAndAdult
	},
	data() {
		// 酒店图片类型名称
		this.imageTypeName = {
			1: '餐厅',
			2: '休闲',
			3: '会议室',
			5: '外观',
			6: '大堂/接待台',
			8: '客房',
			10: '其他',
			11: '公共区域',
			12: '周边景点',
		}
		this.InvoiceTypeName = {
			1: "专票",
			2: "普票",
		};
		this.ShortRuleType = {
			wxdb: 11, // 无需担保
			xsdb: 12, // 限时担保
			qzdb: 13, // 强制担保
			freeCancel: 21, // 免费取消
			limitCancel: 22, // 限时取消
			noCancel: 23, // 不可取消
		}
		this.TripTypeMap = {
			onbusiness: "1", // 因公
			onprivacy: "2", // 因私
		}
		return {
			imgList: [],
			imgViewerVisible: false,
			visible: false,
			errImgB: require('@/assets/image/htcnbgc/hotel_zwt.jpg'),
			errImg: require('@/assets/image/htcnbgc/hotel_zwt_s.jpg'),
			clzcStr: '',
			byNumber: '10903',
			reasonCode: '', // 违背编码
			reasonDesc: '', // 违背原因
			hotelRatePlans: {}, //房间信息
			roomItem: {}, // 房间类型信息
			loading: false, //
			objArrImg: [], //
			hotelItem: {}, //列表页传入过来的item
			detalisInfo: {}, //请求接口获取的详情,
			hotelImgs: [],
			roomsImgs: [],
			timeDefaultShow: [],
			dateValue: '',
			isShowRomms: true,
			seePriceInfo: {},
			hotelSelectValue: '',
			roomList: [],
			seePriceShow: false, // 人工询价布尔值
			tabsShow: 1,
			dialogShow: false,
			athoerHoterParams: '',
			athoerHoterList: [],
			firstImage: '',
			loadingAll: false,
			shortRules: {
				11: '无需担保',
				12: '限时担保',
				13: '强制担保',
				21: '免费取消',
				22: '限时取消',
				23: '不可取消',
			},
			allRoomStatusRules: {
				0: '充足',
				1: '紧张',
				2: '满房',
				3: '需确认',
			},
			options: [
				{
					fyid: '',
					label: '全部',
				},
				{
					fyid: '12004',
					label: '艺龙',
				},
				{
					fyid: '12005',
					label: '道旅',
				},
				{
					fyid: '12006',
					label: '亚朵',
				},
				{
					fyid: '12007',
					label: '华住',
				},
				{
					fyid: '12008',
					label: '锦江',
				},
			],
			value: '',
			showAllImg: false, // 显示所有图片
			typeImgArray: [], // 分类好的图片
			showIdx: 0, // 显示第几张图片
			travelStandardsFilter: false,
			roomInfoList: [],
			BussType: {
				fws: 1,
				xyj: 2,
			},
			toBook: false,
			currentRatePlan: null,
			currentRoom: null,
			showRzxz: false,
			showWbPop: false,
			wbList: [],
			searchParams: {
				nationality: 'CN',
				nationalityName: '中国',
				nationalityId: '00002'
			},
			gjList: []
		}
	},
	computed: {
		...mapState({
			htCnQuery: (state) => state.intHt.htCnQuery,
			htCnCcsqD: (state) => state.intHt.htCnCcsqD,
			htCnPolicy: (state) => state.intHt.htCnPolicy,
			htCnParams: (state) => state.intHt.htCnParams,
			// ccsqdInfo: (state) => state.common.ccsqdInfo, // 出差申请单信息
			cxrList: state => state.intHt.cxrList, // 因公出行人
			ysCxrList: state => state.intHt.ysCxrList, // 因私出行人
			rooms: state => state.intHt.rooms,
			selectRoom: state => state.intHt.selectRoom,
			selectRatePlan: state => state.intHt.selectRatePlan,
			wbObj: state => state.intHt.wbObj,
			travelerIds: (state) => state.intHt.travelerIds,
		}),
		...mapGetters({
			roomEmpMap: 'intHt/roomEmpMap',
			getVipParamterByParNo: 'common/getVipParamterByParNo',
			useNameclbz: 'intHt/getUseNameclbz',
		}),
		roomNum: {
      get() {
        return this.htCnParams.roomNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ roomNum: val })
      },
    },
    adultNum: {
      get() {
        return this.htCnParams.adultNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ adultNum: val })
      },
    },
		chooseCxrList() {
			if (this.tripType == 2) {
				return this.ysCxrList || [];
			}
			return (this.cxrList || []);
		},
		// 日期最小，和最大值对象
		bookDateRange() {
			// 方法来自于mixins
			let dateRangeObj = this.getBookDateRange(10903, this.htCnQuery.tripType, 90, this.htCnCcsqD.ccsqdId, this.htCnCcsqD.routeId);
			return dateRangeObj
		},
		gkfsRole() {
			return this.htCnQuery.gkfsRole //0 不管控  1出差申请单管控  2差旅标准管控
		},
		clbzText() {
			return `差旅标准：本次预订每间房价不得高于 ¥${this.jdjgbz}元/间夜`
		},
		bookStyle() {
			// 1单订模式  2出差申请单模式
			let bookStyle = this.$common.getUserInfo().vipCorp.bookStyle
			return bookStyle
		},
		tripType() {
			return this.htCnQuery.tripType /* 默认当前因公因私*/
		},
		// 按差旅标准管控 酒店价格标准
		jdjgbz() {
			console.log('jgjhbz === ', this.htCnPolicy?.policy?.jdjgbz)
			return this.htCnPolicy?.policy?.jdjgbz ?? '0'
		},
		policy() {
			var policy
			if (JSON.stringify(this.htCnPolicy) != '{}') {
				policy = this.htCnPolicy.policy || {}
			}
			return policy || {}
		},
		// 按差旅标准管控  管控方式 1提醒 2不可预定
		gkfs() {
			var gkfs
			if (JSON.stringify(this.htCnPolicy) != '{}') {
				gkfs = this.htCnPolicy.policy.gkfs || ''
			}
			return gkfs || ''
		},
		objArrImgSplice() {
			let arr = []
			let splicPic = this.objArrImg.slice(1, 7)
			for (let i = 0; i < 6; i++) {
				let obj = {}
				if (splicPic[i]) {
					obj.img = splicPic[i]
				} else {
					obj.img = ''
				}
				arr.push(obj)
			}
			return arr
		}
	},
	created() {
		this.hotelItem = this.$route.query;
		this.timeDefaultShow.push(
			this.htCnParams.checkInDate || this.hotelItem.checkInDate,
			this.htCnParams.checkOutDate || this.hotelItem.checkOutDate
		)
		this.dateValue = this.timeDefaultShow
		this.getHotelImage()
		this.getGjList()
	},
	methods: {
		...mapMutations({
			SAVE_HOTELINFO: 'intHt/SAVE_HOTELINFO',
			SAVE_ROOMINFO: 'intHt/SAVE_ROOMINFO',
			SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY',
			SET_HTCN_POLICY: 'intHt/SET_HTCN_POLICY',
			SAVE_SELECTROOM: 'intHt/SAVE_SELECTROOM',
			SAVE_SELECTRATEPLAN: 'intHt/SAVE_SELECTRATEPLAN',
			SET_STATE: 'intHt/SET_STATE',
			SET_HTCN_PARAMS: "intHt/SET_HTCN_PARAMS"
		}),
		getScoreDesc(score) {
			if (!score) return "";
			if (score > 4.7) return score + " 超棒";
			if (score > 4.5) return score + " 很好";
			if (score >= 4) return score + " 好";
			return score + " 一般";
		},
		//筛选
		filterRooms() {

			/**
			 * 	1.判断当前房型是否显示， 受【当前房型价格】显示影响，当存在满足条件的可以显示
			 *  2.判断当前房型的价格是否显示
			 *
			 * **/

			this.roomList = this.roomList.map(roomItem => {
				let newRoomItem = {
					...roomItem,

				}
				newRoomItem.ratePlans = roomItem.ratePlans.map(planItem => {
					let show = true;
					if (this.travelStandardsFilter && planItem.violate) {
						show = false;
					}
					return {
						...planItem,
						show
					}
				})
				let filterRatePlans = newRoomItem.ratePlans.filter(ratePlansItem => {
					return ratePlansItem.show
				})
				newRoomItem.show = filterRatePlans.length > 0

				return newRoomItem
			})

		},
		changeSelect(val) {
			console.log(val, 'vava')
			let selectItem = this.gjList.filter(i => i.id == val)[0]
			let obj = {
				nationalityName: selectItem.label,
				nationality: selectItem.value,
				nationalityId: selectItem.id
			}
			this.searchParams.nationalityName = selectItem.label
			this.searchParams.nationality = selectItem.value
			this.searchParams.nationalityId = selectItem.id
			this.SET_STATE({ chooseNationByCard: obj })
			this.getPlanSearch()
		},
		// 选择房间数 成人数 儿童数回调
		selectRoomNumCallback(item) {
			if (this.tripType == 1) {
				// 分配房间
				let adNum = item.adultNum;
				let num = item.roomNum;
				this.searchParams.roomNum = num
				this.searchParams.adultNum = adNum
				// 人数总量大于房间数*单个房间人数
				if (adNum * num < this.chooseCxrList.length) {
					num = Math.ceil(this.chooseCxrList.length / adNum);
				}
				let hotelRoom = handleIntHotelRoom({ preCxrList: this.chooseCxrList, maxFjs: num, maxNums: adNum });
				this.SET_STATE({
					allRank: hotelRoom.allRank,
					rooms: hotelRoom.rooms,
				})

				if (hotelRoom.rooms && hotelRoom.rooms.length > 0) {
					adNum = hotelRoom.rooms[0].length ?? adNum;
				}

				this.SET_HTCN_PARAMS({
					roomNum: hotelRoom.roomNum, // 房间数
					adultNum: adNum // 每间房成人数
				})
				let empObj = {
					empRank: hotelRoom.minEmpRank, //   职级
					useNameclbz: hotelRoom.minEmpName, // 本次预订使用谁的差旅标准
				}
				this.SET_HTCN_QUERY(empObj)
			} else {
				this.roomNum = item.roomNum;
				this.adultNum = item.adultNum;
				let cRooms = handleIntYsRooms(item.roomNum, item.adultNum, this.rooms);
				console.log('cRooms === ', cRooms);
				this.SET_STATE({
					rooms: cRooms
				})
			}
			this.getPlanSearch()
		},
		changeDate(date) {
			this.SET_HTCN_PARAMS({
				checkInDate: date[0]
			})
			this.SET_HTCN_PARAMS({
				checkOutDate: date[1]
			})
			this.timeDefaultShow = date
			this.dateValue = this.timeDefaultShow
			this.getPlanSearch()
		},
		getGjList() {
			this.$conn.getConn('commu.getBClass')({ parNo: 101 }, (res) => {
				console.log(res)
				this.gjList = []
				res.data.list.forEach(item => {
					this.gjList.push({
						value: item.by3,
						label: item.cName,
						id: item.id
					})
				})
			})
		},
		// 选择右边6张的一个图片
		selectImg(idx) {
			this.showAllImg = true;
			this.showIdx = idx;
		},
		canBook(ratePlansItem) {
			// 满房不可预订
			if (ratePlansItem.allRoomStatus == 2) {
				return false;
			}
			// 不违背 直接可预订
			if (!ratePlansItem.violate) {
				return true;
			}
			// 违背 如果多人差标管控是不可预订则不能预订
			var travelPolicy = this.htCnPolicy ? this.htCnPolicy.policy : {};
			// mulPerson == 1 开启了多入住人差标匹配
			if (travelPolicy.mulPerson == 1) {
				// mulPersonControl == 2 不可预订
				if (travelPolicy.mulPersonControl == 2) {
					return false;
				}
			} else if (travelPolicy.gkfs == 2) { // 未开启多人审批,超标不允许预订
				return false;
			}
			return true;
		},
		pickerOptions(minDay, maxDay) {
			return {
				//定义不可选择时间 暂无预约功能 查找有效日期
				// 查询出差申请单预订行程日期可否变更 0不可更改  1 按行程更改 2 出差申请单日期范围更改
				disabledDate(time) {
					let minTime = new Date(new Date(minDay).toLocaleDateString()).getTime();
					let maxTime = new Date(new Date(maxDay).toLocaleDateString()).getTime();
					return time.getTime() < minTime || time.getTime() > maxTime;
				},
			}
		},
		closeImgViewer() {
			this.imgViewerVisible = false
			this.move()
		},
		move() {
			const m = (e) => { e.preventDefault() };
			document.body.style.overflow = 'auto';
			document.removeEventListener("touchmove", m, true);
		},
		chooseReason(val) {
			this.toPlaceOrder(val);
		},
		cancelReason(bool) {
			this.showWbPop = bool;
		},
		seePriceHander() {
			this.seePriceInfo.checkInDate = this.dateValue[0]
			this.seePriceInfo.checkOutDate = this.dateValue[1]
			this.seePriceInfo.jdmc = this.detalisInfo.jdmc
			this.seePriceInfo.address = this.detalisInfo.address
			this.seePriceInfo.phone = this.detalisInfo.phone
			this.seePriceInfo.jdid = this.hotelItem.jdid,
				this.seePriceShow = !this.seePriceShow
		},
		dialogMap() {
			this.dialogShow = true
		},
		handleTab(val) {
			this.tabsShow = val
		},
		getDetailsInfo() {
			this.$conn.getConn('htbook.interHotelDetailInfoStatic')({
				jdid: this.hotelItem.jdid,
				type: "hotel,room"
			}, (res) => {
				let data = res.data || {};
				this.detalisInfo = data.hotelDetail
				this.SAVE_HOTELINFO(data.hotelDetail)
				if (!this.detalisInfo.baiduLat) {
					this.detalisInfo.baiduLat = this.detalisInfo.googleLat
				}
				if (!this.detalisInfo.baiduLon) {
					this.detalisInfo.baiduLon = this.detalisInfo.googleLon
				}
				this.roomInfoList = res.data.rooms
				this.athoerHoterParams = {
					checkInDate: this.htCnParams.checkInDate,
					checkOutDate: this.htCnParams.checkOutDate,
					cityId: this.detalisInfo.cityId,
					roomNum: this.rooms.length,
					tripType: this.tripType,
					currency: 'CNY',
					// 'nationality': 'KR',
					clientNationality: this.searchParams.nationality,
					count: 10,
					distance: 3,
					exclude: 1,
					hotelId: this.detalisInfo.jdid,
					lat: this.detalisInfo.baiduLat,
					lon: this.detalisInfo.baiduLon,
					pageNum: 1,
					searchType: 3,
					starRate: this.detalisInfo.starRate,
					personInfo: {
						adultCount: this.htCnParams.adultNum,
						childAgeDetails: this.htCnParams.childAgeDetails,
						childCount: this.htCnParams.childNum,
						roomNo: this.rooms.length,
					}
				}
				if (this.athoerHoterParams.lat && this.athoerHoterParams.lon) {
					this.getAthoerHoter(this.athoerHoterParams);
				}
				this.loadingInstance.close();
				this.getPlanSearch()
			}, (err) => {
				this.loadingInstance.close();
				this.$message({
					type: 'error',
					message: err.tips,
				})
			})
		},
		getAthoerHoter(params) {
			// this.$conn.getConn('htbook.interHotelPlanSearch')(params, (res) => {
			// 	this.athoerHoterList = res.data.list || []
			// }, (err) => {

			// })
		},
		getHotelImage() {
			let self = this;
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			loading.$el.style.fontSize = "30px";
			this.loadingInstance = Loading.service(loading);
			this.$conn.getConn('htbook.intHotelImg')({
				jdid: this.hotelItem.jdid,
				type: 'hotel,room',
			}, (res) => {
				var data = res.data || {}
				data.hotelImgs = data.hotelImages || [];
				data.roomsImgs = data.roomImages || [];
				data.hotelImgs = Object.values(
					data.hotelImgs.reduce((acc, item) => {
						if (!acc[item.type]) {
							acc[item.type] = {
								type: item.type,
								url: [],
							};
						}
						acc[item.type]?.url.push(item.imageUrl);
						return acc;
					}, {})
				);
				console.log(data.hotelImgs, 'hotelImgshotelImgs')
				//酒店图片排序
				let hotelImgsObj = {};
				let imgsArray = [];
				const unique = (arr) => {
					let newArray = arr.filter((item, index) => {
						return arr.indexOf(item) === index
					})
					return newArray
				}

				for (let i = 0; i < data.hotelImgs.length; i++) {
					let type = data.hotelImgs[i].type;
					let list = data.hotelImgs[i]?.url;
					hotelImgsObj[type] = list
					imgsArray.push({
						title: this.imageTypeName[type],
						list: unique(list)
					})
				}

				// 1 - 餐厅 (Restaurant) 2 - 休闲 (Recreation Facilities) 3 - 会议室 (Meeting/Conference) 5 - 外观 (Exterior) 6 - 大堂/接待台 (Lobby/ Reception) 8 - 客房 (Guest Room) 10 - 其他 (Other Facilities) 11 - 公共区域 (Public Area) 12 - 周边景点 (Nearby Attractions)
				let sort = ["5", "10", "6", "11", "1", "2", "3", "8", "12"];
				let hotelImgs = [];
				for (let c = 0; c < sort.length; c++) {
					if (hotelImgsObj[sort[c]]) {
						hotelImgs = hotelImgs.concat(hotelImgsObj[sort[c]]);
					}
				}
				imgsArray.unshift({
					title: '全部',
					list: hotelImgs,
				});
				self.typeImgArray = imgsArray;
				this.objArrImg = hotelImgs;
				this.firstImage = this.objArrImg[0];
				this.hotelImgs = data.hotelImgs
				this.roomsImgs = data.roomsImgs
				this.getDetailsInfo()
				// this.loadingInstance.close();
			}, (err) => {
				// this.loadingInstance.close();
				this.$message({
					type: 'error',
					message: err.tips,
				})
			})
		},
		ifShowMore(item, index) {
			if (item.itemShow) {
				return true
			} else {
				if (index < 2) {
					return true
				} else {
					return false
				}
			}
		},
		clickAll(item) {
			item.itemShow = !item.itemShow
		},
		getPlanSearch() {
			this.loading = true
			let params = {
				checkInDate: this.dateValue[0],
				checkOutDate: this.dateValue[1],
				hotelId: this.hotelItem.jdid,
				fyid: this.hotelSelectValue,
				tripType: this.tripType, // 因公因私
			};

			params.cityId = this.hotelItem.cityId;
			// 2023/06/09  13:11 陈伟说： 当没有房间数时，默认按照 一人一间处理
			// 入住人房间：
			params.roomNum = this.rooms.length || this.chooseCxrList.length;
			// 入住人数量
			params.checkInNum = this.chooseCxrList.length;
			var htCnCcsqD = this.htCnCcsqD || {};

			// 出差申请单id
			params.ccsqdId = htCnCcsqD.ccsqdId || '';
			params.routeId = htCnCcsqD.routeId || '';

			// 最低出行人职级
			if (this.$store.state.htCn.cxrList) {
				// let clbzObj = this.getClbzParamMap();
				params = {
					...params,
					// ...clbzObj,
					travelerIds: this.travelerIds,
					minEmpRank: this.htCnQuery.minEmpRank,
					roomNum: this.rooms.length,
					roomEmpMap: this.roomEmpMap,
					tripType: this.tripType,
					currency: 'CNY',
					nationality: 'KR',
					clientNationality: this.searchParams.nationality,
					'personInfo': {
						adultCount: this.htCnParams.adultNum,
						childAgeDetails: this.htCnParams.childAgeDetails,
						childCount: this.htCnParams.childNum,
						roomNo: this.rooms.length,
					}
				}
			}
			this.$conn.getConn('htbook.interHotelPlanSearch')(params, (res) => {
				if (res.data) {
					let travelPolicy = res.data.travelPolicy;
					// policy
					this.SET_HTCN_POLICY({ policy: travelPolicy });
					res.data.rooms.forEach((e) => {
						e.itemShow = false
					})
					let list = res.data.rooms;
					this.roomList = [];
					this.roomList = list.map((item) => {
						item.resRoomInfo = {};
						var arr = this.roomsImgs.filter(i => i.fxid == item.roomId)
						if (arr.length > 0) {
							item.url = arr[0].imageUrl || ''
						} else {
							item.url = ''
						}
						var arr2 = this.roomInfoList.filter(i => i.fxid == item.roomId)
						if (arr2.length > 0) {
							item = {
								...item,
								...arr2[0]
							}
						}
						return item
					})
					console.log(this.roomList, 'rrss')
					this.isShowRomms = true
					this.loading = false
					this.filterRooms();

				} else {
					this.getHtClbz();
					this.loading = false
					this.isShowRomms = false
				}
				// this.loadingInstance.close();
			}, (err) => {
				this.loading = false
				// this.loadingInstance.close();
				this.$message({
					type: 'error',
					message: err.tips,
				})
			})
		},
		// 单订模式下 因公匹配差旅标准
		getHtClbz() {
			if (!this.htCnParams.cityId || this.tripType == 2) return;
			let nowDays = this.$moment().format("YYYY-MM-DD")
			let nextDays = this.$moment().add(1, "days").format("YYYY-MM-DD")
			let params = {
				cityId: this.htCnParams.cityId, //城市或者商圈id
				dateStart: this.htCnParams.checkInDate || nowDays, //日期开始时间
				dateEnd: this.htCnParams.checkOutDate || nextDays, // 日期结束时间
				ccsqdId: this.htCnCcsqD.ccsqdId,
				routeId: this.htCnCcsqD.routeId,
				tripType: 1,
				roomEmpMap: this.roomEmpMap,
			}
			let userInfo = this.$common.getUserInfo();
			params.corpId = userInfo.empInfo.corpId;
			this.$conn.getConn('htbook.interHotelTravelPolicyDetail')(params, (res) => {
				let data = res.data || {};
				let policy = data.policy || {};
				let policyInfo = { policy };
				this.SET_HTCN_POLICY(this.$common.deepCopy(policyInfo))
			})
		},
		// 房型描述
		// 宽带数据转换
		getBroadnetAccess(val) {
			let str = "";
			if (val) {
				var arr = [
					{
						span: "无宽带",
						value: 0,
					},
					{
						span: "有宽带",
						value: 1,
					},
					{
						span: "有WIFI",
						value: 2,
					},
				];
				for (let i in arr) {
					if (arr[i].value == val) {
						str = arr[i].span;
					}
				}
			}
			return str;
		},
		// 预订
		bookRatePlan(planItem, roomItem) {
			console.log('roomItem ==== ', roomItem);
			console.log('planItem ==== ', planItem);
			// 满房不可预订
			if (planItem.allRoomStatus == 2) return;

			// 校验房间数量，每间房必须相同人数
			if (this.rooms && this.rooms.length > 0 && this.tripType == 1) {
				const firstValidCount = this.htCnParams.adultNum || 1;
				const mismatchedRooms = this.rooms.filter(rc => rc.length !== firstValidCount);
				if (mismatchedRooms.length !== 0) {
					this.$confirm('国际酒店下单必须保证每个房间人数相同，如需房间不同人数请分开下单！', '温馨提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					})
					return;
				}
			}
			// 不违背 直接可预订
			if (!planItem.violate) {
				this.book(planItem, roomItem)
				return;
			}
			// 违背 如果多人差标管控是不可预订则不能预订
			let travelPolicy = this.htCnPolicy?.policy || {};
			// mulPerson == 1 开启了多入住人差标匹配
			if (travelPolicy.mulPerson == 1) {
				// mulPersonControl == 2 不可预订
				if (travelPolicy.mulPersonControl == 2) {
					this.$message.error(`当前价格已超标，不可预订！`);
					return;
				}
			} else if (travelPolicy.gkfs == 2) { // 未开启多人审批,超标不允许预订
				this.$message.error(`当前价格已超标，不可预订！`)
				return;
			}
			this.book(planItem, roomItem)
		},
		book(planItem, roomItem) {
			// 入住须知
			if (!!planItem && planItem.hotelPolicy && Object.keys(planItem.hotelPolicy).length > 0) {
				this.toBook = true;
				this.currentRatePlan = planItem;
				this.currentRoom = roomItem;
				this.showRzxz = true;
				return;
			}
			if (!planItem) planItem = this.currentRatePlan;
			if (!roomItem) roomItem = this.currentRoom;
			// 记录当前预订的价格计划
			this.SAVE_SELECTROOM(roomItem)
			this.SAVE_SELECTRATEPLAN(planItem)
			this.hotelValidateManRoom(planItem, roomItem);
		},
		handleClose() {
			this.showRzxz = false
		},
		hasKown() {
			this.showRzxz = false
			this.book()
		},
		// 验证价格
		hotelValidateManRoom(ratePlan, room) {
			let isWb = ratePlan?.violate || '';
			let roomNum = this.rooms.length;
			let personInfos = [];
			for (let i = 0; i < roomNum; i++) {
				let obj = {
					adultCount: this.htCnParams.adultNum,
					childAgeDetails: this.htCnParams.childAgeDetails,
					childCount: this.htCnParams.childNum,
					roomNo: i + 1,
				};
				personInfos.push(obj);
			};

			let params = {
				checkInDate: this.htCnParams.checkInDate, // 入住日期：yyyy-mm-dd ,
				checkOutDate: this.htCnParams.checkOutDate, // 离店日期：yyyy-mm-dd ,
				// checkInDate: '2026-04-24', // 入住日期：yyyy-mm-dd ,
				// checkOutDate: '2026-04-25', // 离店日期：yyyy-mm-dd ,
				hotelId: this.hotelItem.jdid, // 酒店id，本地酒店 ,
				tripType: this.htCnQuery.tripType, // 因公因私
				currency: 'CNY',
				nationality: this.searchParams?.nationalityId, // 入住人国籍
				preBook: false,
				ratePlanId: ratePlan.ratePlanId,
				roomId: room.roomId,
				fyid: ratePlan.fyid,
				roomNum,
				totalPrice: ratePlan.totalRate, // 1间房的价格合计
				personInfos,
				ccsqdId: this.htCnCcsqD.ccsqdId || '',
				clientNationality: this.searchParams?.nationality || 'CN',
				roomEmpMap: this.roomEmpMap,
				routeId: this.htCnCcsqD.routeId,
			};
			// this.loadingAll = true
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			loading.$el.style.fontSize = "30px";

			this.loadingInstance = Loading.service(loading);
			this.$conn.getConn('htbook.interDataValidate')(params, () => {
				this.loadingInstance.close();
				if (isWb) {
					// 选择违背原因
					this.showWbPop = true;
				} else {
					this.toPlaceOrder();
				}
			}, (err) => {
				this.loadingInstance.close();
				this.$message({
					showClose: true,
					message: err.tips,
					type: 'error'
				});
			})
		},
		toPlaceOrder(wbyyItem) {
			let ratePlan = this.selectRatePlan
			let isWeibei = ratePlan?.violate;
			let wbObj = {
				isWeibei,
				violateitem: isWeibei ? `超过${this.htCnPolicy?.policy?.jdjgbz}元/夜` : '',
				violateitemCode: isWeibei ? "11109" : '',
				gkfs: this.htCnPolicy?.policy?.gkfs,
				wbyyItem
			}
			this.SET_STATE({ wbObj })
			this.SET_HTCN_QUERY({
				violateCode: isWeibei ? wbObj.violateitemCode : '', //违背事项代码
				violateItem: isWeibei ? wbObj.violateitem : '', //违背事项说明
				reasonCode: isWeibei ? (wbyyItem?.reasonCode || '') : '', //违背原因代码
				reasonDesc: isWeibei ? (wbyyItem?.reasonDesc || '') : '', //违背原因说明
			})
			this.goToPath();
		},
		goToPath() {
			this.$router.push({
				name: 'intHtEdit',
				query: {},
			})
		},
		getRoomDesc(room) {
			if (!room) return [];
			let desc = [];
			let count = 0;
			desc.push(`${room.hasWindow == 1 || room.window == 1 ? "有窗" : "无窗"}`);
			count++;
			if (!!room.bedType) {
				// 床型:
				desc.push(`${room.bedType}`);
				count++;
			}
			if (count < 3) {
				if (!!room.area) {
					let area = room.area.indexOf("㎡") != -1 ? room.area : `${room.area}㎡`;
					desc.push(`面积:${area}`);
					count++;
				}
			}
			if (count < 3) {
				if (!!room.floor) {
					desc.push(`楼层：${room.floor}`);
					count++;
				}
			}
			if (count < 3) {
				if (!!room.broadnetAccess) {
					desc.push(`网络:${this.getBroadnetAccess(room.broadnetAccess)}`);
					count++;
				}
			}
			return desc;
		},
		getFreeMealStr(freeMeal) {
			if (freeMeal == 1) {
				return "1份早";
			}
			if (freeMeal == 2) return "2份早";
			if (freeMeal > 2) return "多份早";
			return "不含早";
		}
	},
	filters: {
		breakfastTypeName(val = 0) {
			let retStr = '';
			if (val == 1 || val == 2) {
				retStr = val + '份早';
			} else if (val > 2) {
				retStr = '多份早';
			} else {
				retStr = '不含早'
			}
			return retStr
		}
	}
}
</script>

<style lang="scss" scoped="scoped">
.clickbtn {
	border: 1px solid #007aff;
	background-color: #007aff;
	color: #fff;
}

.clickbtn.el-button:focus,
.clickbtn.el-button:hover {
	color: #fff;
	border: 1px solid #007aff;
	background-color: #007aff;
}

body {
	overflow: hidden;
}

html {
	overflow-y: scroll;
}

html {
	overflow: auto;
}

.textRomms {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 20px;
	min-height: 120px;
	margin-top: 20px;
}

.to_active {
	color: #327bdc;
	font-weight: 600;
}

.ht-detail {
	padding-bottom: 100px;
	background-color: #f0f0f0;
	height: 100%;

	.container {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		display: flex;
		background-color: #f0f0f0;

		.container-left {
			width: 856px;
			height: 100%;
			background-color: #f0f0f0;

			.hotel-imgs {
				width: 100%;
				height: 435px;
				background-color: #fff;
				margin-top: 20px;
				display: flex;
				flex-direction: column;
				box-sizing: border-box;
				padding: 20px;

				.imgs-top {
					display: flex;
					align-items: center;

					p {
						font-size: 20px;
						font-weight: bold;
						margin-right: 20px;
					}

					img {
						width: 20px;
						height: 20px;
					}
				}

				.imgs-center {
					display: flex;
					margin-top: 6px;
					// margin-bottom: 24px;
					align-items: center;
				}

				.imgs-bottom {
					display: flex;
					height: 320px;

					.imgs-left {
						position: relative;

						.img {
							width: 504px;
							height: 100%;
						}

						span {
							position: absolute;
							bottom: 20px;
							right: 10px;
							color: #fff;
							cursor: pointer;
						}
					}

					.ims-right {
						display: flex;
						flex-wrap: wrap;
						flex: 1;

						.img:nth-child(3) {
							margin-top: 10px;
							margin-bottom: 10px;
						}

						.img:nth-child(4) {
							margin-top: 10px;
							margin-bottom: 10px;
						}

						.img {
							margin-left: 10px;
							width: 46%;
							height: 31%;
						}
					}
				}
			}

			.left-tabs {
				display: flex;
				width: 856px;
				height: 65px;
				box-sizing: border-box;
				padding: 20px;
				background: #ffff;
				margin-top: 16px;

				span {
					margin-right: 40px;
					font-size: 18px;
					font-weight: bold;
					cursor: pointer;
				}
			}

			.gj-tips {
				background-color: #fff;
				display: flex;
				font-size: 12px;
				color: #666;
				padding: 0 20px;
			}

			.home-search {

				height: 56px;
			}

			.searchItem {
				height: 56px;
				align-items: center;
				display: flex;
				background-color: #fff;
				padding: 0 20px;
			}

			.searchBtn {
				width: 80px;
				height: 34px;
				line-height: 34px;
				text-align: center;
				background-color: #1B8CFF;
				color: #fff;
				cursor: pointer;
			}

			.search-list {
				width: 100%;
				background: #fff;
				box-sizing: border-box;
				padding: 20px;
				display: flex;
				justify-content: space-between;

				.search-left-center {
					display: flex;

					.search-left {
						.img {
							width: 85px;
							height: 85px;
						}
					}

					.search-center {
						margin-left: 20px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						align-items: flex-start;

						.search-center-span {
							font-size: 14px;
							color: #007aff;
						}

						span {
							font-size: 14px;
							color: #808080;
						}

						// span:nth-child(1) {
						// 	font-size: 18px;
						// 	color: black;
						// 	font-weight: bold;
						// }
					}
				}

				.search-right {
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.right-top {
						display: flex;
						align-items: center;

						p:nth-child(1) {
							font-size: 24px;
							color: #007aff;
						}

						p:nth-child(2) {
							font-size: 12px;
							color: #808080;
						}
					}

					.right-bottom {
						width: 55px;
						height: 29px;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 1px solid #f0f0f0;
						cursor: pointer;
					}
				}
			}

			.search-room {
				background-color: #fff;
				box-sizing: border-box;
				// width: 856px;
				padding: 20px;

				.room-header {
					width: 100%;
					height: 40px;
					background-color: #e6e6e6;
					color: #808080;
					display: flex;
					align-items: center;
					box-sizing: border-box;
					padding: 12px 8px 11px 12px;
				}

				.room-body:hover {
					background-color: #e6e6e6;
				}

				.room-body {
					width: 100%;
					height: 65px;
					background-color: #fff;
					display: flex;
					align-items: center;
					box-sizing: border-box;
					padding: 12px 8px 11px 12px;
					border-bottom: 1px solid #f0f0f0;

					.last-body {
						span:nth-child(2) {
							width: 41px;
							height: 21px;
							background-color: #ffefe4;

							font-size: 12px;
							color: #ff6c00;
							box-sizing: border-box;
							padding: 5px;
							margin-right: 10px;
						}

						span:nth-child(1) {
							width: 52px;
							height: 35px;
							background-color: #ff6c00;

							font-size: 14px;
							color: #fff;
							box-sizing: border-box;
							padding: 10px;
						}

						.disabled {
							background-color: #ccc !important;
						}
					}
				}
			}

			.hotel-info {
				width: 855px;
				background-color: #fff;
				box-sizing: border-box;
				padding: 20px;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				margin-top: 20px;

				p {
					font-size: 18px;
					font-weight: bold;
				}

				.info {
					width: 100%;
					color: #424242;
					font-size: 12px;
					display: flex;
					margin-top: 15px;

					span {
						width: 100px;
					}

					.info-right {
						width: 100%;
						margin-left: 50px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						align-items: flex-start;

						p {
							color: #424242;
							font-size: 12px;
							text-align: left;
							margin-bottom: 20px;
						}

						span {
							width: 100%;
							height: 1px;
							background-color: #f0f0f0;
						}
					}
				}
			}
		}

		.container-right {
			margin-top: 20px;
			width: 368px;
			//   height: 100%;
			margin-left: 16px;
			display: flex;
			flex-direction: column;
			background-color: #f0f0f0;

			//   background: pink;
			.map {
				width: 100%;
				height: 100px;
				background-color: #fff;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.standard {
				width: 100%;
				background-color: #fff;
				margin-top: 20px;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				box-sizing: border-box;
				padding: 20px;
				justify-content: space-between;
				text-align: left;
				font-size: 15px;

				p {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 15px;
				}

				span {
					font-size: 12px;

				}

				.clbz-clbzText {
					font-size: 13px;
					font-weight: bold;
					margin: 5px 0;
				}

				.clbz-user {
					font-size: 13px;
					margin: 5px 0;
				}

			}

			.sale {
				display: flex;
				flex-direction: column;
				box-sizing: border-box;
				padding: 20px 20px 66px 20px;
				background-color: #fff;
				margin-top: 20px;

				.sale-top {
					display: flex;
					align-items: center;
					padding-bottom: 24px;
					border-bottom: 1px solid #f0f0f0;

					.top-span {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
						margin-right: 17px;

						p {
							font-size: 18px;
							font-weight: bold;
						}

						span {
							font-size: 12px;
							margin-top: 3px;
						}
					}

					.top-btn {
						width: 80px;
						height: 36px;
						background-color: #fff;
						border: 1px solid #007aff;
						color: #007aff;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}

				.sale-bottom {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					margin-top: 20px;

					p {
						font-size: 18px;
					}

					.sale-list {
						display: flex;
						margin-top: 20px;
						width: 368px;

						img {
							width: 95px;
							height: 65px;
						}

						.list-center {
							margin-left: 10px;
							display: flex;
							flex-direction: column;

							align-items: flex-start;
							//   display: -webkit-box;
							width: 225px;

							P {
								color: #000000;
								font-size: 15px;
								text-align: left;
							}

							span {
								color: #808080;
							}
						}

						span {
							display: flex;
							align-items: flex-end;

							p:nth-child(1) {
								font-size: 18px;
								color: #007aff;
							}

							p:nth-child(2) {
								font-size: 12px;
								color: #808080;
							}
						}
					}
				}
			}
		}
	}
}

.searchBtn {
	width: 80px;
	height: 34px;
	line-height: 34px;
	text-align: center;
	font-size: 12px;
	color: #fff;
	background-color: #1B8CFF;
}

.flexBet {
	display: flex;
	flex: 1;
	justify-content: flex-end;
}

.planSearch {
	background-color: #fff;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 16px;

	.leftBox {
		margin-right: 12px;

		img {
			width: 160px;
			height: 160px;
			border-radius: 4px;
		}

		.fxmc {
			font-size: 16px;
			font-weight: 600;
			color: #222;
			width: 100%;
			text-align: left;
			max-width: 160px
		}

		.cxmc {
			font-size: 12px;
			color: #666666;
			width: 100%;
			text-align: left;
			max-width: 160px
		}
	}

	.rightBox {
		flex: 1;
		border: 1px solid #D9E1ED;
		padding: 12px;
		border-radius: 4px;

		.fxBox {
			height: 98px;
			padding: 16px 12px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #D9E1ED;
		}
	}
}

.flex-x-s {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.flex-x-c {
	display: flex;
	align-items: center;
	justify-content: center;
}

.roomNameStyle {
	font-size: 16px;
	font-weight: 600;
	width: 400px;
	text-align: left;
}

.hyqy-tag {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10rpx 8rpx 10rpx 0;
	padding: 0 6rpx;
	height: 32rpx;
	font-size: 18rpx;
	border-radius: 4rpx;
	background-color: #C5E2FF;
}

.buy-btn {
	margin-left: 6px;
	width: 42px;
	height: 42px;
	border-radius: 8px;
	overflow: hidden;
	// background-color: $uni-color-primary;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.ding {
		width: 100%;
		min-height: 25px;
		font-size: 18px;
		color: #fff;
		flex: 1;
		cursor: pointer;
	}

	.h-tips {
		// flex: 1;
		width: 100%;
		height: 15px;
		background-color: #fff;
		color: #1B8CFF;
		font-size: 10px
	}
}

.lookMore {
	text-align: right;
	height: 40px;
	color: #666;
	font-size: 12px;
	line-height: 40px;
}

.jz-btn {
	border: 1px solid #1B8CFF;

}

.grey-plan {
	opacity: 0.5;
}

.bggrey1 {
	background-color: #9C9C9C;
}

.bgtheme {
	background-color: #1B8CFF;
}

.ctheme {
	color: #1B8CFF;
}

.bgred {
	background-color: #f7613f;
	color: #fff;
	border: none
}

.cred {
	color: #f7613f;

}

.room-tag {
	margin: 4px;
	font-size: 12px;
	padding: 2px 4px;
	border: 1px solid #d1d1d1;
	border-radius: 2px
}

.cb-tag {
	padding: 2px 5px;
	background: linear-gradient(90deg, #F7793F 0%, #FD514E 100%);
	border-radius: 4px;
	margin-right: 4px;
	flex-shrink: 0;
	color: #fff;
}

.rightBtn {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

/deep/ .adult-style {
	height: 32px !important;
}

.yjStyle {
	background-color: #1B8CFF;
	color: #fff;
	border: 1px solid #1B8CFF;
	font-size: 12px;
	width: 54px;
	padding: 4px 8px;
	border-radius: 4px;
}

.pfStyle {
	// background-color: #e6a23c;
	color: #1B8CFF;
	// border: 1px solid #e6a23c;
	font-size: 12px;
	width: 100px;
	padding: 4px 8px;
	border-radius: 4px;
	margin-left: 24px
}

.center-center {
	margin-top: 10px;
	display: flex;
	align-items: center;

	p {
		color: #808080;
		font-size: 14px;
	}

	span {
		font-size: 14px;
		color: #007aff;
		margin-left: 15px;
	}

	.icon-xieyi {
		padding: 2px 10px;
		color: #FFFFFF;
		background-color: #007aff;
		border-radius: 2px;
	}

	.score-text {
		font-size: 14px;
		font-weight: 600;
		color: #1B8CFF;
	}

	.score-desc {
		font-size: 14px;
		font-weight: 600;
		color: #1B8CFF;
		margin-left: 4px;
	}

}
</style>
